/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { CosmosElementDownloadButton, CosmosElementDownloadStep } from "@cosmos/hygraph-schema";

export const getDownloadBtnFromSteps = (
	steps?: CosmosElementDownloadStep[],
): CosmosElementDownloadButton | undefined => {
	let downloadBtn = undefined;
	if (!steps) return downloadBtn;
	for (const step of steps) {
		for (const downloadCard of step.content) {
			if (downloadCard.cta?.__typename === "CosmosElementDownloadButton") {
				downloadBtn = downloadCard.cta;
				break;
			}
		}
	}
	return downloadBtn;
};
